.bodyText {
  word-break: break-all;
  overflow-wrap: anywhere;
  white-space: pre-wrap;
}

.headerValue {
  word-break: break-all;
  overflow-wrap: anywhere;
}

.logs {
  word-break: break-all;
}
